<template>
  <div>

    <TitlePage :title="$t('users')"></TitlePage>

    <v-row class="align-center">

      <v-col cols="12" md="6">
        <v-btn elevation="2" color="secondary" small class="mr-2" :to="pathCreate">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('create') }}
        </v-btn>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('filterResults')" hide-details dense></v-text-field>
      </v-col>

      <v-col cols="12" md="12">
        <ItemActions :selected="selected" @message="actionHandler"></ItemActions>
      </v-col>
    </v-row>

    <v-card tile>

    </v-card>

    <div class="mt-5">
      <div style="text-align: right;font-size: 11px;font-weight: 600;padding-bottom: 5px;">
        <span>{{(items_count) ? items_count:0}} risultati trovati</span>
      </div>
      <v-data-table
          v-model="selected" :headers="headers" :items="items"
          :single-select="false" item-key="_id" show-select class="elevation-1" :search="search"
          disable-pagination hide-default-footer
      >

        <template v-slot:item.action="{ item }">
          <v-icon @click="edit(item._id)" :title="$t('edit')" color="primary">mdi-file-edit</v-icon>
          <v-icon @click="confirmRemove(item._id)" :title="$t('delete')" color="primary">mdi-delete</v-icon>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch v-model="item.active" inset @change="updateSingleStatus(item)" hide-details dense class="mt-0"></v-switch>
        </template>

        <template v-slot:item.center_name="{ item }">
            <span>
              {{
                [
                  item.center && item.center.name,
                  ...(item.additional_centers || []).map(c => c.name)
                ]
                    .filter(Boolean)
                    .join(' , ')
              }}
            </span>
        </template>

        <template v-slot:item.role_id="{ item }">
            <span>
                  {{ getRoleName(item.role_id) }}
            </span>
        </template>

        <template v-slot:item.created_at="{ item }">
          {{new Date(item.created_at).toLocaleString()}}
        </template>

      </v-data-table>
      <div class="text-center pt-3 pb-3">
        <v-row>
          <v-col cols="12" md="10" style="text-align: end">
            <v-pagination
                v-model="options_pagination.page"
                :length="calculatePagination(items_count,options_pagination.limit)"
                :total-visible="10"
                @input="getNewPage()"
            ></v-pagination>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                v-model="options_pagination.limit"
                :items="items_for_page"
                label="Risultati per pagina"
                dense hide-details small-chips outlined @change="makeSearch(true)"/>
          </v-col>
        </v-row>
      </div>

    </div>

    <ModalDelete :modalDelete="modalDelete" @message="removeHandler"></ModalDelete>

  </div>

</template>

<script>

import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import ModalDelete from "@/components/layout/ModalDelete.vue";
import ItemActions from "@/components/layout/ItemActions.vue";
import CenterAutocomplete from "@/components/admin/CenterAutocomplete";

const exportService = require('@/services/export')

export default {
  name: 'Collaborator',
  components: {ItemActions, ModalDelete, TitlePage, CenterAutocomplete},
  data() {
    return {
      pathCreate: '/collaborators/create/',
      pathEdit: '/collaborators/edit/',
      search: '',
      selected: [],
      headers: [
        // { text: this.$t('Id'), align: 'start', value: '_id'},
        { text: this.$t('name'), align: 'start', value: 'full_name'},
        { text: this.$t('email'), align: 'start', value: 'email'},
        { text: this.$t('role'), align: 'start', value: 'role_id'},
        { text: this.$t('sportCenter'), value: 'center_name'},
        { text: this.$t('status'), value: 'status', sortable: false},
        { text: this.$t('creation_date'), value: 'created_at'},
        { text: this.$t('actions'), align: 'start', value: 'action', },
      ],
      items: [],
      items_count: 0,
      ids_to_delete: [],
      modalDelete: false,
      typeDelete: '',
      filter: {},
      options_pagination: {},
      items_for_page:[10, 20, 25, 50, 75, 100],
      roles: []
    };
  },
  async created(){
    let result = await this.getList();
    this.roles = result.role.map((r) => ({ text: this.$t(r.name), value: r._id }));
    this.filter = Object.assign({},this.getFilter)
    this.options_pagination = Object.assign({},this.getOptionsPagination)
    if(!this.getUser.super_admin && this.getUser.center_id){
      this.filter.center_id = this.getUser.center_id
    }else {
      delete this.filter.center_id
    }
    await this.makeSearch()
  },
  computed: {
    ...mapGetters({
      'getFilter':'centerAdmin/getFilter',
      'getOptionsPagination':'centerAdmin/getOptionsPagination',
      'getUser':'user/getUser'
    }),
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),

    ...mapActions({
      'getItems': 'centerAdmin/centerAdminIndex',
      'updateItem':'centerAdmin/centerAdminUpdate',
      'deleteItem': 'centerAdmin/centerAdminDelete',
      'massiveDeleteItem': 'centerAdmin/centerAdminMassDelete',
      'setFilter': 'centerAdmin/setFilter',
      'setOptionsPagination': 'centerAdmin/setOptionsPagination',
      'getList': 'permissions/getList',
    }),
    async resetFilter(){
      var filters = Object.assign({},this.getFilter)
      for (const property in filters) {
        filters[property] = null
      }
      this.filter = Object.assign({}, filters)
      this.options_pagination = Object.assign({},{
        page: 1,
        limit: 10
      })
      await this.makeSearch()
    },

    async makeSearch(reset = null) {
      this.setLoading(true);

      if(reset){
        this.options_pagination.page = 1
      }

      await this.setFilter(this.filter)
      await this.setOptionsPagination(this.options_pagination)
      var results = await this.getItems();

      const currentUserId = this.getUser && this.getUser._id;
      this.items = results.results.filter(item => item._id !== currentUserId);

      this.items_count = this.items.length;
      this.setLoading(false);
    },

    async actionHandler(type) {
      switch (type) {
        case "edit":
          await this.edit(this.selected[0]._id)
          break;
        case "massiveDelete":
          await this.confirmMassiveRemove()
          break;
        case "export":
          await this.export()
          break;
        default:
          break
      }
    },

    edit(id){
      this.$router.push(this.pathEdit+id)
    },

    confirmRemove(id){
      this.ids_to_delete = [id]
      this.modalDelete = true
      this.typeDelete = 'single'
    },

    confirmMassiveRemove(){
      this.ids_to_delete = this.selected.map(x => x._id)
      this.modalDelete = true
      this.typeDelete = 'massive'
    },

    async removeHandler(mode){
      if(this.typeDelete == 'single'){
        await this.remove(mode)
      }else if(this.typeDelete == 'massive'){
        await this.massiveRemove(mode)
      }else {
        this.modalDelete = false
        this.ids_to_delete = []
        this.typeDelete = ''
      }
    },

    async remove(mode){

      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);

        var result = await this.deleteItem({id:this.ids_to_delete[0]})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }

    },
    async massiveRemove(mode){
      if(!mode){

        this.modalDelete = false

      }else{

        this.modalDelete = false
        this.setLoading(true);


        var result = await this.massiveDeleteItem({_id:{$in:this.ids_to_delete}})

        if(result.success){

          this.setNotification({
            active: true,
            color: 'success',
            mode: 'multi-line',
            text: this.$t('deleteSuccess')
          })

          var results = await this.getItems({filter:this.getFilter, pagination:this.getOptionsPagination});
          this.items = results.results
          this.items_count = results.count

          this.selected = []
          this.ids_to_delete = []

          this.setLoading(false);

        }else {

          this.setNotification({
            active: true,
            color: 'error',
            mode: 'multi-line',
            text: result
          })

          this.setLoading(false);
        }
      }
    },
    async updateSingleStatus(item){

      await this.setLoading(true);
      var result = await this.updateItem({id:item._id, item: {active: item.active, email: item.email, password_new: '', center_id: item.center_id}})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },
    async getNewPage(){
      await this.makeSearch()
    },
    calculatePagination(count, limit){

      var divide = (count / limit)
      var rest = divide % 1

      if(rest > 0){
        divide = divide - rest
        divide = +divide.toFixed(0) + 1
      }

      return +divide
    },
    async setCenterId(id){
      this.filter.center_id = id
    },

    async export(){
      var csv = await exportService.getCsv(this.headers, this.items)
      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `export_${new Date().toISOString()}.csv`);
      document.body.appendChild(link); // Required for FF
      link.click();
    },
    getRoleName(id) {
      const role = this.roles.find(r => r.value === id);
      return role ? role.text : '';
    }
  },
  mounted() {

  },
}
</script>
